export default __webpack_public_path__ + "static/media/Path3414.ace0d7b2.svg";